import { Directive, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, inject } from '@angular/core';
import { PermissionAction, PermissionResource } from '@coin/shared/core/util-enums';
import { Subject } from 'rxjs';
import { TinyHelpers } from '@coin/shared/core/util-helpers';
import { takeUntil } from 'rxjs/operators';
import { UserState } from './user.state';
import { PermissionsService } from './permissions.service';

@Directive({
  selector: '[coinPermissionAccess]',
  standalone: true
})
export class DynamicDomAccessDirective implements OnChanges, OnInit, OnDestroy {
  private readonly elementRef = inject(ElementRef);
  private readonly userState = inject(UserState);
  private readonly permissionsService = inject(PermissionsService);

  @Input() allowedResources: PermissionResource[];
  @Input() allowedActions?: PermissionAction[];

  public initialDisplayStyle: string;

  private readonly newValue$ = new Subject<void>();

  ngOnInit(): void {
    this.initialDisplayStyle = this.elementRef.nativeElement.style.display;
    this.elementRef.nativeElement.style.display = 'none';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      this.elementRef?.nativeElement &&
      changes.allowedResources &&
      !TinyHelpers.areItemsSimilar(changes.allowedResources.previousValue, changes.allowedResources.currentValue)
    ) {
      this.newValue$.next();
      this.updateVisibilityBasedOnPermissions();
    }
  }

  private updateVisibilityBasedOnPermissions(): void {
    this.userState.allPermissions$.pipe(takeUntil(this.newValue$)).subscribe(userPermissions => {
      if (userPermissions && this.allowedResources?.length) {
        const allowedActions = this.allowedActions || [PermissionAction.All, PermissionAction.Read];

        if (
          this.permissionsService.hasPermissionsAndActions({
            resources: this.allowedResources,
            actions: allowedActions
          })
        ) {
          setTimeout(() => {
            this.elementRef.nativeElement.style.display = this.initialDisplayStyle;
          });
        } else {
          this.elementRef.nativeElement.remove();
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.newValue$.complete();
  }
}
